'use client';
import React, { useState } from 'react';
import SectionImage from '@/components/(landing)/landing/SectionImage';
// import Link from 'next/link';
import axios from 'axios';
import CloseFillIcon from 'remixicon-react/CloseFillIcon';
import { PaymentDialog } from '@/components/(landing)/landing/layout/PaymentDialog';

// interface ProductsCardProps {
//     data?: { cash: { link: { url: string; title: string } }; installment: { link: { url: string; title: string } } };
// }

const ProductsCard = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [, setIsConnecting] = useState<boolean>(false);
    const handlePayment = async (
        amount: number,
        description: string, // will receive triggerText from PaymentDialog
        extras: { phone: string; email: string }, // from dialog form
    ) => {
        const { phone, email } = extras;
        setIsConnecting(true);

        try {
            const res = await axios.post('/api/nokhbegan/payment', {
                amount,
                description,
                mobile: phone, // what your API expects (will be forwarded to metadata.mobile)
                email, // optional
            });

            const { authority, message, error, code } = res.data || {};

            // Redirect only when we have a valid authority
            if (typeof authority === 'string') {
                const host = phone === '09358088118' ? 'sandbox' : 'payment';
                window.location.assign(`https://${host}.zarinpal.com/pg/StartPay/${authority}`);
                return;
            }

            // Otherwise, show the reason we got back from server/Zarinpal
            console.error('Zarinpal request failed:', { message, error, code, data: res.data });
            alert(error || message || 'درخواست پرداخت ناموفق بود.');
        } catch (err: any) {
            const serverError = err?.response?.data;
            console.error('Payment Request Error:', serverError || err);
            alert(serverError?.error || 'درخواست پرداخت با خطا مواجه شد.');
        } finally {
            setIsConnecting(false);
        }
    };
    return (
        <section id='producs-card' className='bg-primary-dark -mt-2 pt-5 pb-24'>
            <div className='max-w-5xl mx-auto max-lg:px-5 pt-3'>
                <SectionImage imageUrl={'/nokhbegan/15-shop-card.webp'} />
                <div className={'grid md:grid-cols-2 mt-10 gap-5'}>
                    <div className='border flex overflow-hidden flex-col bg-primary-hover gap-3 relative border-[#EEAC43] p-4 pt-6 rounded-2xl text-white'>
                        <div className='flex gap-1 items-center'>
                            <span className='opacity-60 font-light'>پرداخت</span>
                            <span className='font-bold text-3xl'>اقساطی</span>
                        </div>
                        <div className='flex justify-between items-center'>
                            <span className='opacity-40 text-sm'>مبلغ دوره به صورت اقساط</span>
                            <div className={'text-lg'}>
                                <span className='font-bold me-2'>۳۹</span>
                                <span className='opacity-70'>میلیون تومان</span>
                            </div>
                        </div>
                        <div className='flex justify-between items-center'>
                            <span className='opacity-40 text-sm'>اولین قسط</span>
                            <div className={'text-lg'}>
                                <span className='font-bold me-2'>۷</span>
                                <span className='opacity-70'>میلیون تومان</span>
                            </div>
                        </div>
                        <PaymentDialog
                            buttonId={'nokhbegan-installment'}
                            triggerText={'پرداخت اولین قسط'}
                            amount={70000000}
                            onPay={handlePayment}
                        />
                    </div>
                    <div className='border flex overflow-hidden flex-col bg-[#eae4d9] gap-3 relative border-[#EEAC43] p-4 pt-6 rounded-2xl text-black'>
                        <span className='absolute bg-[#EEAC43] top-0 end-0 hidden text-black  rounded-br-2xl p-1 px-3 py-1 text-sm '>
                            اشتراک پرطرفدار
                        </span>
                        <div className='flex gap-1 items-center'>
                            <span className='opacity-60 font-light'>پرداخت</span>
                            <span className='font-bold text-3xl'>نقدی</span>
                        </div>
                        <div className='flex justify-between items-center'>
                            <span className='opacity-40 text-sm'>مبلغ دوره به صورت نقدی</span>
                            <div className={'line-through text-lg'}>
                                <span className='font-bold me-2'>۳۹</span>
                                <span className='opacity-70'>میلیون تومان</span>
                            </div>
                        </div>
                        <div className='flex justify-between items-center'>
                            <span className='opacity-40 text-sm'>قیمت با تخفیف</span>
                            <div className={'text-lg'}>
                                <span className='me-2'>۳۵</span>
                                <span className='opacity-70'>میلیون تومان</span>
                            </div>
                        </div>
                        <PaymentDialog
                            buttonId={'nokhbegan-cash'}
                            triggerText={'خرید نقدی دوره'}
                            amount={350000000}
                            onPay={handlePayment}
                        />
                    </div>
                </div>
                <p className='!text-white hidden text-center mx-auto max-lg:text-xs w-fit mt-5'>
                    خرید اشتراک به معنای پذیرفتن
                    <button onClick={() => setModalOpen(true)} className='mx-1 text-[#EEAC43]'>
                        قوانین و مقررات
                    </button>
                    توسط شما است.
                </p>
                <div
                    onClick={() => setModalOpen(false)}
                    className={`bg-black/80 backdrop-blur-lg fixed inset-0 transition-opacity duration-500 ${modalOpen ? 'z-[49]' : 'opacity-0 z-[-1]'}`}
                ></div>
                <div
                    className={`bg-white dark:bg-primary-dark fixed z-50 top-1/2 start-1/2 translate-x-1/2 -translate-y-1/2 overflow-hidden w-11/12 md:w-3/5 lg:w-1/3 rounded-xl duration-500 transition-all ${modalOpen ? '' : 'scale-0 opacity-0'}`}
                >
                    <div
                        className={
                            'bg-gray-100 dark:bg-primary-dark flex justify-between items-center p-3 border-b dark:border-white/30'
                        }
                    >
                        <p className={'font-bold dark:!text-white text-lg'}>قوانین و مقررات</p>
                        <button
                            onClick={() => setModalOpen(false)}
                            aria-label='Close modal'
                            title='Close modal'
                        >
                            <CloseFillIcon
                                size={27}
                                className='text-primary dark:text-white'
                                role='img'
                                aria-hidden='true'
                            />
                        </button>
                    </div>
                    <div className={'p-5 dark:bg-white/10 h-full flex flex-col justify-end'}>
                        <h3 className={'text-primary dark:text-white text-2xl mb-5'}>
                            قوانین و مقررات دوره آموزش ارز دیجیتال
                        </h3>
                        <p
                            className={
                                'text-sm leading-[1.7] !text-black/70 dark:!text-white/70 mb-4'
                            }
                        >
                            {' '}
                            شرکت در این دوره آموزشی به منزله‌ی پذیرش کامل تمامی قوانین و شرایط ذکر
                            شده می‌باشد. محتوای ارائه‌شده در این دوره صرفاً جهت آموزش و افزایش دانش
                            شرکت‌کنندگان در حوزه ارزهای دیجیتال بوده و هیچ‌گونه توصیه‌ی مالی،
                            سرمایه‌گذاری یا تضمین سودآوری محسوب نمی‌شود. مسئولیت هرگونه تصمیم‌گیری
                            مالی یا سرمایه‌گذاری بر عهده‌ی شخص شرکت‌کننده می‌باشد.
                        </p>
                        <p className={'text-sm leading-[1.7] !text-black/70 dark:!text-white/70'}>
                            {' '}
                            تمامی حقوق مادی و معنوی محتوای دوره، از جمله ویدئوها، فایل‌ها، مطالب
                            آموزشی و منابع ارائه‌شده، متعلق به برگزارکننده دوره می‌باشد و هرگونه
                            کپی‌برداری، بازنشر، فروش مجدد یا استفاده‌ی تجاری از محتوا بدون کسب
                            اجازه‌ی کتبی ممنوع است. در صورت نقض این موارد، پیگرد قانونی در چارچوب
                            قوانین جمهوری اسلامی ایران انجام خواهد گرفت.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductsCard;
